import { END_POINTS } from '../helpers';
import { CommonBody, RoleTypes, SubadminTypes } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponseType = {
  status: number;
  message: string;
  statusCode: number;
  page: number;
  limit: number;
  data: any;
};
type GetSubadminsResponse = {
  limit: number;
  page: number;
};

export const subadminApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    // roles

    getAllRoles: builder.query<
      CommonResponseType & {
        data: { SubAdminAccess: RoleTypes[]; count: number };
      },
      {}
    >({
      query: () => ({
        url: END_POINTS.getSubAdmin,
        method: 'GET',
      }),
    }),

    deleteRole: builder.query<CommonResponseType & { data: RoleTypes }, { id: string | null }>({
      query: ({ id }) => ({
        url: `${END_POINTS.subadminaccess}/${id}`,
        method: 'DELETE',
      }),
    }),

    roleDetail: builder.query<
      CommonResponseType & { data: RoleTypes | null },
      { id: string | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.subadminaccess}${id}`,
        method: 'GET',
      }),
    }),
    updateRole: builder.mutation<
      CommonResponseType & { data: RoleTypes },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.subadminaccess}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
    addRole: builder.mutation<CommonResponseType & { data: RoleTypes }, CommonBody>({
      query: (body) => ({
        url: END_POINTS.subadminaccess,
        method: 'POST',
        body,
      }),
    }),

    // subadmins
    allsubAdmin: builder.query<CommonResponseType, { page: number; limit: number }>({
      query: ({ page, limit }) => ({
        url: `${END_POINTS.getsubAdmins}?page=${page}&limit=${limit}`,
        method: 'GET',
      }),
    }),

    deleteSubadmin: builder.query<
      CommonResponseType & { data: SubadminTypes },
      { id: string | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.subadmin}/${id}`,
        method: 'DELETE',
      }),
    }),

    subadminDetail: builder.query<
      CommonResponseType & { data: SubadminTypes | null },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.subadmin}/${id}`,
        method: 'GET',
      }),
    }),
    updateSubadmin: builder.mutation<
      CommonResponseType & { data: SubadminTypes },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.subadmin}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
    addSubadmin: builder.mutation<CommonResponseType & { data: SubadminTypes }, CommonBody>({
      query: (body) => ({
        url: END_POINTS.subadmin,
        method: 'POST',
        body,
      }),
    }),
    changeSubadminStatus: builder.mutation<
      CommonResponseType & { data: SubadminTypes },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.subadmin}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetAllRolesQuery,
  useLazyDeleteRoleQuery,
  useLazyRoleDetailQuery,
  useAddRoleMutation,
  useUpdateRoleMutation,

  //Subadmins
  useAddSubadminMutation,
  useUpdateSubadminMutation,
  useLazyDeleteSubadminQuery,
  useLazySubadminDetailQuery,
  useLazyAllsubAdminQuery,
  useChangeSubadminStatusMutation,
} = subadminApi;
